import CategoriesModule from './containers/categoriesModule'

export {default as CategoriesModuleLayout} from './components/categoriesModuleLayout'

export default CategoriesModule
